export default __webpack_public_path__ + "static/media/publications.74ab80f7.png";